import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  ErrorBox,
} from "@gearbox-protocol/deploy-tools-ui";
import { api } from "api";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import { useAsyncFn } from "react-use";

interface ForkPauseDialogProps {
  alias: string;
  paused?: boolean;
  open?: boolean;
  onOpen?: (open: boolean) => void;
}

const ForkPauseDialog: FC<ForkPauseDialogProps> = props => {
  const { alias, paused, open, onOpen } = props;
  const navigate = useNavigate();

  const [{ loading, error }, submit] = useAsyncFn(async () => {
    await api.setPaused(alias, !paused);
    navigate("/");
  }, [alias, paused, navigate]);

  return (
    <Dialog modal open={open} onOpenChange={onOpen}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>{paused ? "Unpause fork" : "Pause fork"}</DialogTitle>
          <DialogDescription>Please confirm action</DialogDescription>
        </DialogHeader>

        {!!error && <ErrorBox error={error} />}

        <DialogFooter>
          <Button
            type="submit"
            variant="destructive"
            disabled={loading}
            loading={loading}
            onClick={submit}
          >
            {paused ? "Unpause fork" : "Pause fork"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ForkPauseDialog;
